


















































































































































































import Vue from 'vue'
import moment from 'moment'
import { GET_CURRENT_USER_ID, GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import {
  DELETE_NOTE_ATTACHMENT,
  FETCH_NOTE_ATTACHMENT_LIST, SAVE_COMMISSION_NOTE,
  SAVE_NOTE_ATTACHMENT
} from '@/store/action-types'
import _ from 'lodash'
import { TranslateResult } from 'vue-i18n'
import { SnackbarStateEnum } from '@/types/enums'
import { SaveNoteAttachmentPayload, UpsertKommissionNotizenRequest } from '@/types/payload'
import {
  DeleteNoteAttachmentResponse,
  GetNoteAttachmentListResponse, KommissionNoteUpsertResponse,
  SaveNoteAttachmentResponse
} from '@/types/service-response'
import ImageGalleryDialog from '@/components/master-data/address/ImageGalleryDialog.vue'
import { CommissionNote } from '@/model/commissions/CommissionNote'
import { CommissionNoteEmployee } from '@/model/commissions/CommissionNoteEmployee'
import { CommissionNoteType } from '@/model/commissions/CommissionNoteType'
import { Commission } from '@/model/commissions/Commission'

interface EventFile extends Event {
  target: HTMLInputElement & EventTarget
}

interface ComponentData {
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  inSaveProgress: boolean

  title: string
  validationRules: Array<Function>
  selectedResponsibleEmployee: number | null
  menu1: boolean
  menu2: boolean
  dateStartIso: string | null
  dateStartFormatted: string | null
  dateEndIso: string | null
  dateEndFormatted: string | null
  alreadyDone: number
  selectedAuthor: number | null
  isPrivate: boolean
  noteType: number | null
  noteTitle: string
  noteText: string
  showImageGallery: boolean
  imageList: string[]
  imageIdList: number[]
  deleteLoading: boolean
  dateRules: Function[]
}

export default Vue.extend({
  name: 'CommissionNotesDialog',

  components: {
    ImageGalleryDialog
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    employeeList: Array as () => CommissionNoteEmployee[],
    notesData: Object as () => CommissionNote,
    noteTypeList: Array as () => CommissionNoteType[],
    commissionId: Number,
    commission: Object as () => Commission,
  },

  data (): ComponentData {
    const required = (value: any): boolean | string => !!value || this.$t('masterData.addresses.required').toString()

    return {
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      inSaveProgress: false,

      title: '',
      validationRules: [required],
      selectedResponsibleEmployee: null,
      menu1: false,
      menu2: false,
      dateStartIso: null,
      dateStartFormatted: '',
      dateEndIso: null,
      dateEndFormatted: '',
      alreadyDone: 0,
      selectedAuthor: null,
      isPrivate: false,
      noteType: null,
      noteTitle: '',
      noteText: '',
      showImageGallery: false,
      imageList: [],
      imageIdList: [],
      deleteLoading: false,
      dateRules: [
        (value: string) => {
          const pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
          return value ? value.length >= 1 ? pattern.test(value) || this.$t('errors.wrongDate').toString() : true : true
        },

        (value: string) => {
          return !!value
        },

        () => {
          //@ts-ignore
          return this.isDatesValid
        }
      ],
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    currentUserId (): number {
      return this.$store.getters[GET_CURRENT_USER_ID]
    },

    selectedLocale (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    isDatesValid (): boolean {
      if(this.dateStartIso && moment(this.dateStartIso, 'YYYY-MM-DD').isValid() && this.dateEndIso && moment(this.dateEndIso, 'YYYY-MM-DD').isValid()) {
        return this.dateEndIso && moment(this.dateEndIso, 'YYYY-MM-DD').isBefore(moment(this.dateStartIso, 'YYYY-MM-DD')) ? false : true

      } else {
        return true
      }
    }
  },

  watch: {
    dateStartFormatted (newVal: string | null): void {
      if(newVal) {
        this.dateStartIso = moment(newVal, 'DD.MM.YYYY').isValid() ?  moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD') : ''
      } else {
        this.dateStartIso = ''
      }
    },

    dateEndFormatted (newVal: string | null): void {
      if(newVal) {
        this.dateEndIso = moment(newVal, 'DD.MM.YYYY').isValid() ?  moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD') : ''
      } else {
        this.dateEndIso = ''
      }
    },
  },

  methods: {
    onBlurStartDate (): void {
      this.dateStartFormatted = this.dateStartIso && moment(this.dateStartIso).isValid() ? moment(this.dateStartIso).format('DD.MM.YYYY') : ''
      setTimeout(() => {
        if(this.menu1) {
          this.menu1 = false
        }
      }, 100)
    },

    onBlurEndDate (): void {
      this.dateEndFormatted = this.dateEndIso && moment(this.dateEndIso).isValid() ? moment(this.dateEndIso).format('DD.MM.YYYY') : ''
      setTimeout(() => {
        if(this.menu2) {
          this.menu2 = false
        }
      }, 100)
    },

    onDateStartIsoChange (date: string): void {
      this.dateStartFormatted = moment(date).format('DD.MM.YYYY')
    },

    onDateEndIsoChange (date: string): void {
      this.dateEndFormatted = moment(date).format('DD.MM.YYYY')
    },

    onAddImageClick (): void {
      //@ts-ignore
      this.$refs.fileInput.click()
    },

    onFileChange (e: EventFile): void {
      if (e && e.target.files) {
        const files: File | undefined = e.target.files[0]

        if (files) {
          const reader = new FileReader()

          reader.readAsDataURL(files)
          reader.onload = (e: any) => {
            if (e.target && e.target.result) {
              if(this.notesData && this.notesData.id) {
                let type: string = e.target.result.split('/')[1].split(';')[0]
                let image = e.target.result.split(',')[1]

                const payload: SaveNoteAttachmentPayload = {
                  NoteId: this.notesData.id!,
                  File: image,
                  FileExtension: type
                }

                this.saveNoteAttachment(payload)
              } else {
                this.imageList.push(e.target.result)
              }

              /*const img = new Image()
              // @ts-ignore
              img.src = e.target.result
              img.onload = () => {
                const elem = document.createElement('canvas')
                /*const scaleFactor = 200 / img.width
                elem.width = 200
                elem.height = img.height * scaleFactor*/
                /*elem.width = img.width
                elem.height = img.height
                const ctx = elem.getContext('2d')

                //ctx!.drawImage(img, 0, 0, 200, img.height * scaleFactor)
                ctx!.drawImage(img, 0, 0, img.width, img.height)
                ctx!.canvas.toBlob((blob: any) => {
                  new File([blob], 'image', {
                    //type: 'image/png',
                    lastModified: Date.now()
                  })
                }, 'image/jpeg', 1)
                this.imageList.push(elem.toDataURL('image/jpeg', 1))
              }*/
            }
          }
        }
      }
    },

    onShowImageClick (): void {
      this.showImageGallery = true
    },

    onCloseImageGalleryDialog (): void {
      this.showImageGallery = false
      setTimeout(() => {
        const galleryButton: any = this.$refs['galleryButton']
        if (galleryButton) {
          galleryButton.$el.focus()
        }
      }, 0)
    },

    onCloseButtonClick (): void {
      this.$emit('close')
    },

    onCancelButtonClick (): void {
      this.$emit('close')
    },

    onDeleteFromImageList (item: number): void {
      this.imageList.splice(item, 1)
      if(this.imageList.length === 0) {
        this.showImageGallery = false
        setTimeout(() => {
          const typeField: any = this.$refs['typeField']
          if (typeField) {
            typeField.focus()
          }
        }, 0)
      }
    },

    async onDeleteFromImageIdList (item: number): Promise<void> {
      const imageNumber: number = this.imageIdList[item]

      try {
        this.deleteLoading = true
        let response: DeleteNoteAttachmentResponse = await this.$store.dispatch(DELETE_NOTE_ATTACHMENT, imageNumber)
        this.deleteLoading = false
        if(!response.IsError && response.Deleted) {
          this.imageIdList.splice(item, 1)
          if(this.imageList.length === 0) {
            this.onCloseImageGalleryDialog()
          }
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.deleteLoading = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    onSaveButtonClick (): void {
      const form: any = this.$refs['form']
      if (form.validate()) {

        const payload: UpsertKommissionNotizenRequest = {
          ID: this.notesData ? this.notesData.id : 0,
          Kommission: this.commissionId,
          Art: this.noteType!,
          Erledigt: this.alreadyDone,
          Author: this.selectedAuthor!,
          Verantwortlich: this.selectedResponsibleEmployee!,
          Beginn: this.dateStartIso!,
          Faellig: this.dateEndIso!,
          Titel: this.noteTitle,
          Beschreibung: this.noteText,
          BeschreibungRtf: this.notesData ? this.notesData.beschreibungRTF : '',
          Privat: this.isPrivate,
          Herkunft: this.notesData ? this.notesData.herkunft : 0,
          //Adresse: this.commission && this.commission.adressID ? this.commission.adressID : null,
          //SachbearbeiterID: null
        }

        this.saveNote(payload)

      }
    },

    async saveNote (payload: UpsertKommissionNotizenRequest): Promise<void> {
      this.inSaveProgress = true
      try {
        let response: KommissionNoteUpsertResponse = await this.$store.dispatch(SAVE_COMMISSION_NOTE, payload)
        if(!response.IsError && response.NoteId) {
          this.messageSnackbar = response.Result ? response.Result : this.$t('success.dataHaveBeenSaved')
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
          this.imageList.forEach((item: string) => {
            let type: string = item.split('/')[1].split(';')[0]
            let image = item.split(',')[1]

            const payload: SaveNoteAttachmentPayload = {
              NoteId: response.NoteId,
              File: image,
              FileExtension: type
            }
            this.saveNoteAttachment(payload)
          })
          this.$emit('dialogSaved')
        } else {
          this.messageSnackbar = response.Result ? response.Result : this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      } finally {
        this.inSaveProgress = false
      }
    },

    async fetchNoteAttachmentList (): Promise<void> {
      try {
        let response: GetNoteAttachmentListResponse = await this.$store.dispatch(FETCH_NOTE_ATTACHMENT_LIST, this.notesData.id)
        if(!response.IsError) {
          if(response.Data) {
            this.imageIdList = response.Data
          }
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async saveNoteAttachment (payload: SaveNoteAttachmentPayload): Promise<void> {
      try {
        let response: SaveNoteAttachmentResponse = await this.$store.dispatch(SAVE_NOTE_ATTACHMENT, payload)
        if(!response.IsError && response.AttachmentId) {
          this.imageIdList.push(response.AttachmentId)
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    }
  },

  mounted (): void {
    if(this.notesData && this.notesData.id) {
      this.title = this.$t('masterData.addresses.editNote').toString()
      const noteData: CommissionNote = _.cloneDeep(this.notesData)

      this.selectedResponsibleEmployee = noteData.responsibleEmployee
      this.dateStartIso = noteData.dateStartIso ? moment(noteData.dateStartIso, "YYYY-MM-DD HH:mm:ss").format('YYYY-MM-DD') : ''
      this.dateStartFormatted = this.dateStartIso.length > 0 ? this.dateStartIso = moment(this.dateStartIso).format('DD.MM.YYYY') : ''
      this.dateEndIso = noteData.dateEndIso ? moment(noteData.dateEndIso, "YYYY-MM-DD HH:mm:ss").format('YYYY-MM-DD') : ''
      this.dateEndFormatted = this.dateEndIso.length > 0 ? this.dateEndIso = moment(this.dateEndIso).format('DD.MM.YYYY') : ''
      this.alreadyDone = noteData.alreadyDone
      this.selectedAuthor = noteData.author
      this.isPrivate = noteData.isPrivate
      this.noteType = noteData.noteType
      this.noteTitle = noteData.noteTitle
      this.noteText = noteData.noteText

      this.fetchNoteAttachmentList()

    } else {
      this.title = this.$t('masterData.addresses.addNote').toString()
      this.selectedResponsibleEmployee = this.currentUserId
      this.selectedAuthor = this.currentUserId
      this.dateStartIso = moment().format('YYYY-MM-DD')
      this.dateStartFormatted = moment(this.dateStartIso).format('DD.MM.YYYY')
      this.dateEndIso = moment().format('YYYY-MM-DD')
      this.dateEndFormatted = moment(this.dateEndIso).format('DD.MM.YYYY')
    }

    setTimeout(() => {
      const focusedField: any = this.$refs['focusedField']
      if (focusedField) {
        focusedField.focus()
      }
    }, 0)
  }
})
